var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import AbstractTask from './abstract-task';
import Exception from '../exception/exception';
import FileHelper from '@vertical-plus/vue-js-core/dist/util/content/file-helper';
import qs from 'qs';
export default class AbstractRestTask extends AbstractTask {
    /**
     * Executes the request
     *
     * @returns
     */
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.getEncodedData(this.data);
            const config = {
                baseURL: this.baseUrl,
                url: this.url,
                method: this.method,
                params: this.params,
                paramsSerializer: p => qs.stringify(p, { arrayFormat: 'brackets' }),
                data,
                headers: this.headers,
            };
            // Get the request response
            try {
                const response = yield axios.request(config);
                return response;
            }
            catch (error) {
                // Throw a TokenExpired exception if this is the failure
                if (this.authenticated && this.isTokenExpired(error.response)) {
                    throw new Error(Exception.TokenExpired);
                }
                // Otherwise return the response as the code will be handled by the concrete task
                else {
                    return error.response;
                }
            }
        });
    }
    /**
     * Encodes the data so that it is suitable for the API
     *
     * @param data
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getEncodedData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const key in data) {
                const value = data[key];
                // Check to see if this is an AttachmentInterface
                if (value && typeof value === 'object' && 'filename' in value && value.filename && 'data' in value && value.data) {
                    // Convert the data to a base64 encoded string to play nice with larger attachments
                    value.data = yield FileHelper.Uint8Arraytobase64(value.data);
                }
            }
            return data;
        });
    }
    /**
     * Returns the base url
     */
    get baseUrl() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.API_BASE_URL;
    }
    /**
     * Returns body parameters
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get data() {
        return null;
    }
    /**
     * Returns whether the token has expired
     *
     * @param response
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isTokenExpired(response) {
        return (response.status === 401 && response.data.message === 'Expired JWT Token');
    }
    /**
     * Parses standard search results from a response
     *
     * @param response
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseSearchResults(response) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // Configure base properties
        const searchResults = {
            results: response.data['hydra:member'],
            totalResults: response.data['hydra:totalItems'],
            totalPages: 1,
            page: 1,
            firstPage: '',
            lastPage: '',
            previousPage: '',
            nextPage: '',
        };
        // Calculate total pages
        if (searchResults.results.length === searchResults.totalResults) {
            searchResults.totalPages = 1;
        }
        else {
            searchResults.totalPages = Math.ceil(searchResults.totalResults / searchResults.results.length);
        }
        // Get current page
        searchResults.page = ((_b = (_a = response.config) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.page) ? (_d = (_c = response.config) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.page : 1;
        if ((_e = response.data) === null || _e === void 0 ? void 0 : _e['hydra:view']) {
            const pagination = response.data['hydra:view'];
            // Get first page url
            if (pagination === null || pagination === void 0 ? void 0 : pagination['hydra:first']) {
                searchResults.firstPage = pagination['hydra:first'];
            }
            else {
                searchResults.firstPage = response.config.url;
            }
            // Get last page url
            if (pagination === null || pagination === void 0 ? void 0 : pagination['hydra:last']) {
                searchResults.lastPage = pagination['hydra:last'];
            }
            else {
                searchResults.lastPage = response.config.url;
            }
            // Get previous page url
            if ((_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f['hydra:view']) === null || _g === void 0 ? void 0 : _g['hydra:previous']) {
                searchResults.previousPage = response.data['hydra:view']['hydra:previous'];
            }
            else {
                searchResults.previousPage = searchResults.lastPage;
            }
            // Get next page url
            if ((_j = (_h = response.data) === null || _h === void 0 ? void 0 : _h['hydra:view']) === null || _j === void 0 ? void 0 : _j['hydra:next']) {
                searchResults.nextPage = response.data['hydra:view']['hydra:next'];
            }
            else {
                searchResults.nextPage = searchResults.lastPage;
            }
        }
        // Return the results
        return searchResults;
    }
}
//# sourceMappingURL=abstract-rest-task.js.map